let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lJ8L3")).then(() => parcelRequire('5HAMb'));